__turbopack_context__.v({
  "ad": "breedHandbookAd-module-scss-module__dze8gq__ad",
  "body": "breedHandbookAd-module-scss-module__dze8gq__body",
  "cta": "breedHandbookAd-module-scss-module__dze8gq__cta",
  "eyebrow": "breedHandbookAd-module-scss-module__dze8gq__eyebrow",
  "photo": "breedHandbookAd-module-scss-module__dze8gq__photo",
  "photoFrame": "breedHandbookAd-module-scss-module__dze8gq__photoFrame",
  "photoImage": "breedHandbookAd-module-scss-module__dze8gq__photoImage",
  "rule": "breedHandbookAd-module-scss-module__dze8gq__rule",
  "text": "breedHandbookAd-module-scss-module__dze8gq__text",
  "title": "breedHandbookAd-module-scss-module__dze8gq__title",
});
